<template>
  <div class="news-content">
    <div class="news-tile">
      <div class="news-icon">
        <img src="@/assets/news.svg" width="40px" alt="" />
        <h1 style="margin-left: 20px">{{ lang == "EN" ? "新闻" : "News" }}</h1>
      </div>

      <span class="more" @click="more">{{ lang == "EN" ? "更多" : "More" }} >></span>
    </div>

    <div>
      <div
        v-for="(item, index) in news"
        :key="index"
        class="news-item"
        @click="newClick(index)"
      >
        <div class="img-bord">
          <img :src="item.img ? item.img : imgUrl" width="100" alt="" />
        </div>

        <span class="overflow">
          {{ lang == "EN" ? item.summary : item.enSummary }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    news: Array,
    lang: String,
  },

  data() {
    return {
      imgUrl: require("../assets/news1.svg"),
    };
  },
  methods: {
    more() {
      console.log("____________");
      this.$emit("newsItemClick", 0);
    },
    newClick(index) {
      console.log(this.news[index]);
      this.$emit("newsItemClick", this.news[index]);
    },
  },
};
</script>

<style scoped>
.overflow {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  font-size: 18px;
  color: rgb(56, 56, 56);
}
.news-content {
  text-align: left;
  line-height: normal;
}

.news-tile {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.news-icon {
  display: flex;
  align-items: center;
  width: 200px;
}

.news-item {
  line-height: 140px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 1em;
  padding-left: 20px;
  cursor: pointer;
  border-bottom: solid 1px #e1e1e1;
  display: flex;
  align-items: center;
}

.more {
  color: #409eff;
  cursor: pointer;
}

.img-bord {
  height: 120px;
  width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
}
</style>
